import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';

import { BaseFormComponent } from '../../../../shared/crud/base-form.component';
import { LayoutUtilsService } from './../../../../core/_base/crud/utils/layout-utils.service';
import { checkPasswords } from './../../../../shared/validators/check-passwords.validator';

@Component({
  selector: 'app-forgot-password-reset',
  templateUrl: './forgot-password-reset.component.html',
  styleUrls: ['./forgot-password-reset.component.scss'],
})
export class ForgotPasswordResetComponent
  extends BaseFormComponent
  implements OnInit, OnDestroy
{
  constructor(
    private authService: AuthAdminService,
    private fb: FormBuilder,
    protected cdr: ChangeDetectorRef,
    protected activatedRoute: ActivatedRoute,
    protected layoutUtilsService: LayoutUtilsService,
    protected router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.handleCompanyKey();
    super.initForm();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  createForm() {
    this.form = this.fb.group(
      {
        confirmationToken: [
          this.activatedRoute.snapshot.params.token,
          [Validators.required],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.pattern('(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}'),
            Validators.maxLength(50),
          ],
        ],
        retypedPassword: ['', [Validators.required]],
      },
      { validators: [checkPasswords] }
    );
  }

  submit() {
    if (!this.validateForm()) {
      this.cdr.detectChanges();
      return;
    }

    this.loadingSubject.next(true);
    const reset = this.form.getRawValue();

    this.subscriptions.push(
      this.authService
        .forgotPasswordReset(reset)
        .pipe(
          finalize(() => {
            this.loadingSubject.next(false);
            this.cdr.detectChanges();
          })
        )
        .subscribe(
          () => {
            this.layoutUtilsService?.showActionNotification({
              title: 'Senha resetada com sucesso!',
              html: `Sua senha foi alterada e agora já pode ser utilizada para acessar o sistema.`,
              icon: 'success',
              heightAuto: false
            });

            this.router?.navigate([
              '/' +
                this.activatedRoute?.parent?.snapshot.params.companyToken +
                '/auth/login',
            ]);
          },
          () => {
            this.form.controls.newPassword.reset();
            this.form.controls.retypedPassword.reset();

            this.layoutUtilsService?.showToastNotification({
              title: 'Não foi possível efetuar o procedimento',
              icon: 'error',
            });
          }
        )
    );
  }
}
